/* Offcanvas menu */
jQuery(function($) {

  // Pannello & pulsante
  var $btn = $('[data-toggle="offcanvas"]'),
      $pnl = $('#offcanvas');
  $btn.on('click', function(e) {
    e.preventDefault();
    $pnl.toggleClass('open');
    var on = $pnl.is('.open');
    $btn.toggleClass('active', on).attr('aria-expanded', on);
    if ( on ) { $pnl.trigger('focus'); }
  }).attr('aria-expanded',false);
  $pnl.on('click', function(e) {
    if ($(e.target).is($pnl) && $(this).is('.open')) {
      $(this).removeClass('open');
      $btn.removeClass('active').attr('aria-expanded',false).focus();
    }
  }).attr('tabindex',-1);
  $(document).on('keyup', function(e) {
    // Bind key esc
    if (e.which === 27) {
      $btn.trigger('click').trigger('focus');
    }
  });

});
